import { useIntl } from "react-intl";
import { connect } from "react-redux";
// import { Button } from "primereact/button";
import {
  LearningProgramWidget,
  CompliancePassportWidget,
  CircularProgressWidget,
  LearningBannerWidget,
  ProgramStatusWidget,
  NotificationAlerts,
} from "../../widgets";

const MyDashboard = ({ enterprise }) => {
  const intl = useIntl();
  const { learnerSettings = {} } = enterprise?.learningConfiguration || {};
  const { showLearningBanner, showLearningStats, customLabels } =
    learnerSettings;
  return (
    <div className="edexlms-full-wrap-height">
      {(showLearningBanner && (
        <LearningBannerWidget showLearningStats={showLearningStats} />
      )) ||
        null}
      <div className="edexlms-page-content">
        <div className="edexlms-page-header">
          <div className="edexlms-page-title">
            {customLabels?.dashboard || intl.formatMessage({ id: "dashboard" })}
          </div>
          <div className="edexlms-page-actions">
            {/* <Button
              outlined
              icon="pi pi-objects-column"
              onClick={() => {}}
              size="small"
              label={intl.formatMessage({ id: "customise" })}
              type="button"
              disabled={!canCustomiseDashboard}
              tooltipOptions={{ showOnDisabled: true, position: "left" }}
              tooltip={
                canCustomiseDashboard
                  ? ""
                  : intl.formatMessage({ id: "no_permission" })
              }
            /> */}
          </div>
        </div>
        <div
          className={`edexlms-page-body dashboard ${
            showLearningBanner ? "with-banner" : "without-banner"
          }`}
        >
          <div className="grid">
            <div className="col-12 md:col-4">
              <CircularProgressWidget />
            </div>
            <div className="col-12 md:col-4">
              <ProgramStatusWidget />
            </div>
            <div className="col-12 md:col-4">
              <NotificationAlerts />
            </div>
            <div className="col-12 md:col-12">
              <LearningProgramWidget linkHeader={true} />
            </div>
            <div className="col-12">
              <CompliancePassportWidget />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  enterprise: state?.global?.enterprise,
});

export default connect(mapStateToProps)(MyDashboard);
